export default __webpack_public_path__ + "static/media/hm.6c812d2e.png";